
const defaultSymptom = {
    name: "",
}

export default defaultSymptom;
